import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import Header from 'components/Header';
import Loading from 'components/Loading';
import BarCodeNum from 'components/BarCodeNum'
import styles from './index.less';
import { usePageBackgroundColor } from '@/utils/theme';

import getQrcode, { clearTimer } from './getQrcode';
import { generateQrcodeTraceId } from './traceId';
import { dateFormat } from '@/utils';
import { getShowTopBar, getValue } from '@/utils/getValue';

const UseSucModal = React.lazy(() => import('components/UseSucModal'));

const pageBackgroundColor = usePageBackgroundColor;

const languageMap = {
  'zh-cn': {
    GoBack: '返回',
    Title: '刷卡使用',
    Tips: '请将此页面展示给工作人员进行扫码',
    AccessLounge: '使用休息室',
    qrcodeExpiredTip1: '二维码已失效',
    qrcodeExpiredTip2: '点击重新获取',
    expiredTip1: '截屏无效，请在',
    expiredTip2: '秒内使用',
    barTitle: '条形码数字',
    showBarCode: '点击展示条形码数字核销',
    secondAfterTip: ' 秒自动刷新，重新打开本页面将刷新条形码数字',
    barCodeTip: '条形码数字仅用于核销时向前场人员展示，请勿泄露以防权益遭受损失',
    regetBarCode: '重新获取',
    regetTip: '条形码数字获取失败，请点击',
    regetQrcodeTip: '二维码已失效，点击刷新后，使用时请重新扫码'
  },
  en: {
    GoBack: 'Go Back',
    Title: 'QR Code Access',
    Tips: 'Please show this screen to lounge staff to access.',
    AccessLounge: 'Access Lounge',
    qrcodeExpiredTip1: 'Your QR code is expired,',
    qrcodeExpiredTip2: 'please retrieve a new QR code again.',
    expiredTip1: 'Screen capture is not allowed, please use the QR code in ',
    expiredTip2: 'seconds.',
    barTitle: 'Barcode numbers',
    showBarCode: 'Click the barcode to register the cardholder',
    secondAfterTip: ' seconds automatic refresh, re-open this page will refresh the barcode number',
    barCodeTip: 'The barcode numbers are only used for showing to the front personnel to get access to, please do not disclose to prevent the loss of rights and interests',
    regetBarCode: 'get it again',
    regetTip: 'Failure to obtain the barcode number, please click to ',
    regetQrcodeTip: 'The QR code has been invalidated. After clicking refresh, please scan the QR code again when using'
  },
};

@connect(({ use, loading }) => ({
  qrcodeMsg: use.qrcodeMsg,
  loading: loading.effects['use/queryflushQrcode'],
}))
class Use extends Component {
  constructor(props) {
    super(props);
    this.qrcodeTraceId = generateQrcodeTraceId();
    this.state = {
      second: 60,
      tipLayer: false,
      record: {},
      timeTimer: null,
      timeString: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
      showExpiredTip: false, // 20240123添加 是否展示截屏无效提示，如果有flushTime就默认展示。（因为存在薅羊毛以及前场区分不了是截图还是h5所以默认有倒计时都打开）
    };
  }

  componentDidMount() {
    this.onQrcode();
  }

  onQrcode() {
    const { dispatch } = this.props;
    const { dragoncode, language } = this.props.location.query;
    getQrcode(dispatch, { dragoncode, language }, this.qrcodeTraceId, (flushTime, res) => {
      const hasFlushTime = flushTime && flushTime !== 0;
      // 保存过期秒数
      if (hasFlushTime) {
        this.setState({ tipLayer: false, second: flushTime, showExpiredTip: true });
      }
      if (hasFlushTime) {
        this.timer = setInterval(() => {
          this.setState(
            {
              second: this.state.second - 1,
            },
            () => {
              if (this.state.second === 0) {
                clearInterval(this.timer);
                if (res.risk) {
                  this.setState({ tipLayer: true });
                  return
                } 
                this.onQrcode();
                
              }
            },
          );
        }, 1000);
      }
    });
    this.showTime();
  }
  showTime() {
    this.timeTimer = setInterval(() => {
      this.setState({
        timeString: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
      });
    }, 1000);
  }
  onCancel() {
    window.history.go(-1);
  }

  hideLayer() {
    this.onQrcode();
  }
  componentWillUnmount() {
    clearInterval(this.timer);
    clearInterval(this.timeTimer);
    clearTimer();
  }
  onGetBarcode(cb, dragoncode,lg) {
    this.props.dispatch({
      type: 'use/getBarcode',
      payload: { 
        language: lg,
        dragoncode: dragoncode.split(' ').join(''),
      },
      callback: cb
    });
  }
  render() {
    const { showExpiredTip } = this.state;
    const { qrcodeMsg, loading } = this.props;
    const channel = this.props.location.query.channel;
    const lg = this.props.location.query.language || localStorage.getItem('language') || 'zh-cn';
    let dragoncode = qrcodeMsg && qrcodeMsg.dragoncode;
    dragoncode = dragoncode && dragoncode.replace(/\s/g, '').replace(/(.{4})/g, '$1 ');
    const showTopBar = getShowTopBar();
    return (
      <Fragment>
        <Header title={languageMap[lg].AccessLounge} />

        {/* <Loading loading={loading}> */}
          <div className="mainContent">
            <div
              className={styles.useCardWrap}
              style={{ background: pageBackgroundColor[channel] }}
            >
              <div
                className={styles.useCardInner}
                style={{
                  top: showTopBar ? '1.4rem' : '0.4rem',
                  height: lg==='en'?'10.8rem': '9.8rem'
                }}
              >
                <div className={styles.useCard}>
                  <div className={styles.useCardTop} style={{ height: qrcodeMsg.isShowCompanyLogo? '2.4rem': '1.4rem'}}>
                    {qrcodeMsg.isShowCompanyLogo && <div className={styles.logoBox}><img className={styles.logo} src={qrcodeMsg.companyLogo || require('@/assets/images/comLogo.png')} /></div>}
                    {/* <div className={styles.title}>{languageMap[lg].Title}</div>
                    <div className={styles.tip}>{languageMap[lg].Tips}</div> */}
                    <div className={styles.cancel} onClick={this.onCancel}>
                      {languageMap[lg].GoBack}
                    </div>
                    {/* 通过channel，显示对应logo */}
                  </div>
                  <div className={styles.useCardBottom}>
                    {dragoncode && !qrcodeMsg.risk && (
                      <div className={styles.cardNo}>{dragoncode}</div>
                    )}
                    {dragoncode && qrcodeMsg.risk && qrcodeMsg.showBarCode && <div style={{ marginTop: '30px'}}><BarCodeNum 
                      loading={loading}
                      getBarcode={(cb)=>this.onGetBarcode(cb, dragoncode,lg )}
                      lgData={languageMap[lg]}
                      showLogo={qrcodeMsg.isShowCompanyLogo}
                      logo={qrcodeMsg.companyLogo}
                      /></div>}
                    <div className={styles.timeStr}>{this.state.timeString}</div>
                    <div className={styles.qrCode}>
                      <img src={qrcodeMsg.base64Data} alt="" />
                      {this.state.tipLayer && (
                      <div
                        className={styles.refreshBox}
                        onClick={() => this.hideLayer()}
                      >
                        <img src={require('@/assets/images/refresh.png')}/>
                      </div>
                    )}
                    </div>
                    {showExpiredTip && (
                      <div className={styles.expiredTip}>
                        {!this.state.tipLayer ?
                        <>{languageMap[lg].expiredTip1} <span style={{color: '#F34242'}}>{this.state.second}</span>{' '}
                        {languageMap[lg].expiredTip2}</> : languageMap[lg].regetQrcodeTip}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {channel === 'haier' && (
                <div className={styles.textTip}>
                  您可通过“海尔智家app-我的-我的奖品”，查看并出示凭证二维码
                </div>
              )}
            </div>
          </div>
        {/* </Loading> */}

        {/* {this.state.tipLayer && (
          <div
            className={styles.layerWrap}
            style={{ top: qrcodeMsg.risk ?lg==='en'?'6.78rem': '6.6rem' : '6.2rem' }}
            onClick={() => this.hideLayer()}
          >
            <div className={styles.layerInner}>
              <div>{languageMap[lg].qrcodeExpiredTip1}</div>
              <div>{languageMap[lg].qrcodeExpiredTip2}</div> 
             
              <img src={require('@/assets/images/refresh.png')}/>
            </div>
          </div>
        )} */}

        <React.Suspense fallback={'加载中...'}>
          <UseSucModal />
        </React.Suspense>
      </Fragment>
    );
  }
}

export default Use;
